/**
 * DeSight Shopify X | v1.0.0
 * Veranstaltungen Component
 *
 * Enterprise-Level Veranstaltungen mit Filter, Sortierung, Pagination und Kalender-Ansicht
 */

(function () {
  'use strict';

  /**
   * Grid-Blocking: Andreas & Nicole Override
   * Wenn ein "Andreas & Nicole" Event existiert, werden Events die NUR Andreas
   * oder NUR Nicole sind im selben Zeitraum ausgeblendet.
   */
  function applyGridBlocking() {
    var grids = document.querySelectorAll('.desight-events__grid');
    grids.forEach(function (grid) {
      var items = grid.querySelectorAll('.desight-events__item');

      // 1. Finde alle Multi-Day Events und deren Blocking-Ranges
      var blockedRanges = [];
      items.forEach(function (item) {
        var z = item.getAttribute('data-zustaendig');
        var sd = item.getAttribute('data-startdatum') || '';
        var ed = item.getAttribute('data-enddatum') || sd;
        if (!sd || sd === ed) return; // Nur Multi-Day
        if (z === 'Andreas & Nicole') {
          blockedRanges.push({ start: sd, end: ed, persons: ['Andreas', 'Nicole'] });
        } else if (z === 'Andreas' || z === 'Nicole') {
          blockedRanges.push({ start: sd, end: ed, persons: [z] });
        }
      });
      if (blockedRanges.length === 0) return;

      // 2. Verstecke Einzel-Personen-Events die in einen Blocked-Range fallen
      //    (Multi-Day Events selbst NICHT verstecken — sie sind die Blocking-Quelle)
      items.forEach(function (item) {
        var z = item.getAttribute('data-zustaendig');
        if (z !== 'Andreas' && z !== 'Nicole') return;
        var sd = item.getAttribute('data-startdatum');
        var ed = item.getAttribute('data-enddatum');
        if (!sd) return;
        if (ed && ed !== sd) return; // Multi-Day → nie verstecken
        for (var i = 0; i < blockedRanges.length; i++) {
          var br = blockedRanges[i];
          if (br.persons.indexOf(z) !== -1 && sd >= br.start && sd <= br.end) {
            item.style.setProperty('display', 'none', 'important');
            item.setAttribute('data-filtered', 'true');
            return;
          }
        }
      });
    });
  }

  /**
   * Veranstaltungen Manager
   */
   var _escapeDiv = document.createElement('div');
   var badgeColorMap = {
     'Andreas': '#d4a574',
     'Nicole': '#a8c9a5',
     'Katharina': '#c9b8e8',
'Constanze': '#a8c5da',
     'Alle': '#d4c98a',
     'Andreas & Nicole': '#d4b896'
   };

   function initEvents() {
    const grids = document.querySelectorAll('.desight-events__grid');
    const calendars = document.querySelectorAll('.desight-events__calendar');

    // Blocking ZUERST anwenden BEVOR CalendarManager Events lädt
    applyGridBlocking();

    if (grids.length) {
      grids.forEach(function (grid) {
        new EventsManager(grid);
      });
    }

    if (calendars.length) {
     calendars.forEach(function (calendar) {
       new CalendarManager(calendar);
       var container = calendar.closest('[data-view-container]');
       if (container) container.classList.add('is-initialized');
     });
    }

    initViewToggle();
  }

  /**
   * View Toggle zwischen Grid und Kalender
   */
  function initViewToggle() {
    var toggles = document.querySelectorAll('.desight-events__view-toggle');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      var buttons = toggle.querySelectorAll('.desight-events__view-btn');
      var section = toggle.closest('.color, .color-scheme-gradient, [class*="color-"]');
      if (!section) section = toggle.closest('.page-width, .isolate');

      var gridView = section ? section.querySelector('[data-view-container="grid"]') : null;
      var calendarView = section ? section.querySelector('[data-view-container="calendar"]') : null;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var view = this.getAttribute('data-view');

          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');

          if (view === 'grid') {
            if (gridView) gridView.style.display = '';
            if (calendarView) calendarView.style.display = 'none';
          } else if (view === 'calendar') {
            if (gridView) gridView.style.display = 'none';
            if (calendarView) calendarView.style.display = '';

            // Blocking anwenden bevor CalendarEvents geladen werden
            applyGridBlocking();

            if (calendarView && !calendarView.classList.contains('is-initialized')) {
              calendarView.classList.add('is-initialized');
              var cal = calendarView.querySelector('.desight-events__calendar');
              if (cal && !cal._calendarManager) {
                new CalendarManager(cal);
              }
            } else if (calendarView) {
              // Calendar bereits initialisiert → Events neu laden nach Blocking
              var cal2 = calendarView.querySelector('.desight-events__calendar');
              if (cal2 && cal2._calendarManager) {
                cal2._calendarManager.reload();
              }
            }
          }
        });
      });
    });
  }

  /**
   * Events Manager Class
   */
  function EventsManager(grid) {
    this.grid = grid;
    this.sectionId = grid.getAttribute('data-section-id');
    this.itemsPerPage = parseInt(grid.getAttribute('data-items-per-page')) || 9;
    this.sortBy = grid.getAttribute('data-sort-by') || 'startdatum';
    this.sortOrder = grid.getAttribute('data-sort-order') || 'asc';

    this.items = Array.from(grid.querySelectorAll('.desight-events__item'));
    this.currentPage = 1;
    this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);

    // Pagination-Elemente
    this.paginationPrev = document.querySelector('.desight-events__pagination-btn--prev');
    this.paginationNext = document.querySelector('.desight-events__pagination-btn--next');
    this.paginationCurrent = document.querySelector('.desight-events__pagination-current');
    this.paginationTotal = document.querySelector('.desight-events__pagination-total');

    this.init();
  }

  EventsManager.prototype = {
    /**
     * Initialisierung
     */
    init: function () {
      // Event-Listener
      this.attachEventListeners();

      // Initial sortieren und anzeigen
      this.sortItems();
      this.updateDisplay();
    },

    /**
     * Event-Listener anhängen
     */
    attachEventListeners: function () {
      // Pagination
      if (this.paginationPrev) {
        this.paginationPrev.addEventListener('click', this.handlePrevPage.bind(this));
      }

      if (this.paginationNext) {
        this.paginationNext.addEventListener('click', this.handleNextPage.bind(this));
      }
    },

    /**
     * Items sortieren
     */
    sortItems: function () {
      const sortBy = this.sortBy;
      const sortOrder = this.sortOrder;

      this.items.sort(function (a, b) {
        let aValue, bValue;

        switch (sortBy) {
          case 'startdatum':
            aValue = a.getAttribute('data-startdatum') || '';
            bValue = b.getAttribute('data-startdatum') || '';
            break;

          case 'ort':
            aValue = a.querySelector('.desight-events__field--ort .desight-events__field-value');
            bValue = b.querySelector('.desight-events__field--ort .desight-events__field-value');
            aValue = aValue ? aValue.textContent.trim() : '';
            bValue = bValue ? bValue.textContent.trim() : '';
            break;

          case 'zustaendig':
            aValue = a.getAttribute('data-zustaendig') || '';
            bValue = b.getAttribute('data-zustaendig') || '';
            break;

          default:
            return 0;
        }

        if (aValue < bValue) {
          return sortOrder === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortOrder === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },

    /**
     * Anzeige aktualisieren
     */
    updateDisplay: function () {
      this.items.forEach(function (item) {
        item.setAttribute('data-filtered', 'true');
      });

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      const pageItems = this.items.slice(start, end);

      pageItems.forEach(function (item) {
        item.setAttribute('data-filtered', 'false');
      });

      this.updatePagination();
    },

    /**
     * Pagination aktualisieren
     */
    updatePagination: function () {
      if (!this.paginationCurrent) return;

      this.paginationCurrent.textContent = this.currentPage;
      this.paginationTotal.textContent = this.totalPages;

      if (this.paginationPrev) {
        this.paginationPrev.disabled = this.currentPage === 1;
      }

      if (this.paginationNext) {
        this.paginationNext.disabled = this.currentPage === this.totalPages;
      }
    },

    handlePrevPage: function () {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateDisplay();
        this.scrollToTop();
      }
    },

    handleNextPage: function () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateDisplay();
        this.scrollToTop();
      }
    },

    scrollToTop: function () {
      const gridTop = this.grid.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({
        top: gridTop,
        behavior: 'smooth'
      });
    }
  };

  /**
   * Kalender Manager Class
   */
   function CalendarManager(calendar) {
     this.calendar = calendar;
     calendar._calendarManager = this;
     this.sectionId = calendar.getAttribute('data-section-id');
     this.clickAction = calendar.getAttribute('data-click-action') || 'modal';
     this.currentDate = new Date();
     this.currentMonth = this.currentDate.getMonth();
     this.currentYear = this.currentDate.getFullYear();
     this.events = [];
     this.eventsByDate = {};
     this.recurringEvents = [];
     this.multiDayEvents = [];
     this.popup = null;
     this.monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
     this.weekdayNames = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

    this.init();
  }

  CalendarManager.prototype = {
    init: function () {
      this.loadEvents();
      this.attachEventListeners();
      this.render();
    },

    reload: function () {
      this.events = [];
      this.eventsByDate = {};
      this.recurringEvents = [];
      this.multiDayEvents = [];
      this.loadEvents();
      this.render();
    },

     loadEvents: function () {
       const self = this;
       const sectionId = this.sectionId;
       const today = new Date();
       today.setHours(0, 0, 0, 0);
       const todayKey = self.formatDateKey(today);

       const gridElement = document.getElementById('Slider-' + sectionId);
       if (!gridElement) return;

       var seenRecurring = {};
       var seenSingle = {};

       const items = gridElement.querySelectorAll('.desight-events__item');
       var filterAll = this.filterAll;
       var activeFilters = this.activeFilters || [];
       if (activeFilters.length === 0) filterAll = true;
        items.forEach(function (item, idx) {
          if (item.style.display === 'none') return;
          var z = item.getAttribute('data-zustaendig');
          if (!filterAll && activeFilters.indexOf(z) === -1) return;
          var eventData = self.extractEventData(item, idx);

          if (eventData.weekday) {
            var rKey = eventData.title + '|' + eventData.weekday;
            if (!seenRecurring[rKey]) {
              seenRecurring[rKey] = true;
              self.recurringEvents.push(eventData);
            }
            return;
          }

          if (!eventData.startdatum) return;

          var isMultiDay = eventData.enddatum && eventData.enddatum !== eventData.startdatum;
          if (isMultiDay) {
            if (eventData.enddatum < todayKey) return;
            var mKey = eventData.title + '|' + eventData.startdatum;
            if (!seenSingle[mKey]) {
              seenSingle[mKey] = true;
              self.multiDayEvents.push(eventData);
            }
          } else {
            if (eventData.startdatum < todayKey) return;
            var sKey = eventData.title + '|' + eventData.startdatum;
            if (!seenSingle[sKey]) {
              seenSingle[sKey] = true;
              if (!self.eventsByDate[eventData.startdatum]) {
                self.eventsByDate[eventData.startdatum] = [];
              }
              self.eventsByDate[eventData.startdatum].push(eventData);
            }
          }
          self.events.push(eventData);
        });
     },

     getMultiDayInfo: function (dateKey) {
       for (var i = 0; i < this.multiDayEvents.length; i++) {
         var mde = this.multiDayEvents[i];
         if (dateKey >= mde.startdatum && dateKey <= mde.enddatum) {
           var color = badgeColorMap[mde.zustaendig] || '';
           if (dateKey === mde.startdatum && dateKey === mde.enddatum) {
             return { label: mde.title, position: 'single', event: mde, color: color };
           } else if (dateKey === mde.startdatum) {
             return { label: mde.title, position: 'start', event: mde, color: color };
           } else if (dateKey === mde.enddatum) {
             return { label: mde.title, position: 'end', event: mde, color: color };
           } else {
             return { label: mde.title, position: 'middle', event: mde, color: color };
           }
         }
       }
       return null;
     },

     extractEventData: function (item, idx) {
       const titleEl = item.querySelector('.desight-events__title');
       const linkEl = item.querySelector('.desight-events__link');
       const imgEl = item.querySelector('.desight-events__image');
       const descEl = item.querySelector('.desight-events__description');
       const startdatum = item.getAttribute('data-startdatum') || '';
       const enddatum = item.getAttribute('data-enddatum') || '';

       const knownWeekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
       var weekday = '';
       var zeitfenster = '';

       const timeTags = item.querySelectorAll('.desight-events__time .desight-events__tag');
       timeTags.forEach(function (tag) {
         var text = tag.textContent.trim();
         var hasStrong = tag.querySelector('strong');
         if (knownWeekdays.indexOf(text) !== -1) {
           weekday = text;
         } else if (!hasStrong) {
           zeitfenster = text;
         }
       });

       var id = item.getAttribute('data-event-id');
       if (!id) id = 'evt-' + idx;

       return {
         id: id,
         title: titleEl ? titleEl.textContent.trim() : '',
         startdatum: startdatum,
         enddatum: enddatum,
         zeitfenster: zeitfenster,
         weekday: weekday,
         externalUrl: linkEl ? linkEl.getAttribute('href') : '',
         imageSrc: imgEl ? (imgEl.getAttribute('src') || '') : '',
         imageAlt: imgEl ? (imgEl.getAttribute('alt') || '') : '',
         description: descEl ? descEl.innerHTML : '',
         zustaendig: item.getAttribute('data-zustaendig') || ''
       };
     },

    attachEventListeners: function () {
      const self = this;

      // Navigation
      const prevBtn = this.calendar.querySelector('.desight-events__calendar-nav--prev');
      const nextBtn = this.calendar.querySelector('.desight-events__calendar-nav--next');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          self.navigateMonth(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          self.navigateMonth(1);
        });
      }

       // Keyboard Navigation - ESC on document level
       document.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') {
           self.closePopup();
         }
       });
    },

    navigateMonth: function (direction) {
      this.currentMonth += direction;
      if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear--;
      }
      this.render();
    },

    render: function () {
      const monthLabel = this.calendar.querySelector('.desight-events__calendar-month');
      const yearLabel = this.calendar.querySelector('.desight-events__calendar-year');
      const daysContainer = this.calendar.querySelector('.desight-events__calendar-days');

      if (monthLabel) {
        monthLabel.textContent = this.monthNames[this.currentMonth];
      }
      if (yearLabel) {
        yearLabel.textContent = this.currentYear;
      }

      this.renderDays(daysContainer);
    },

    renderDays: function (container) {
      if (!container) return;
      const self = this;
      const firstDay = new Date(this.currentYear, this.currentMonth, 1);
      const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
      const daysInMonth = lastDay.getDate();
      const startingDay = (firstDay.getDay() + 6) % 7;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let html = '';

      // Leere Tage vor dem ersten Tag
      for (let i = 0; i < startingDay; i++) {
        html += '<div class="desight-events__calendar-day is-empty"></div>';
      }

       // Tage rendern
       for (let day = 1; day <= daysInMonth; day++) {
         const date = new Date(this.currentYear, this.currentMonth, day);
         const dateKey = this.formatDateKey(date);
         const dayEvents = this.eventsByDate[dateKey] || [];
         const isToday = date.getTime() === today.getTime();
         const isPast = date < today;

         // Wiederholende Events für diesen Wochentag
         const dayIndex = (date.getDay() + 6) % 7;
         const weekdayAbbr = this.weekdayNames[dayIndex];
         const weekdayMap = {
           'Mo': 'Montag', 'Di': 'Dienstag', 'Mi': 'Mittwoch',
           'Do': 'Donnerstag', 'Fr': 'Freitag', 'Sa': 'Samstag', 'So': 'Sonntag'
         };
         const dayWeekday = weekdayMap[weekdayAbbr];
          const recurringDayEvents = isPast ? [] : this.recurringEvents.filter(function (e) {
            return e.weekday === dayWeekday;
          });

            var allDayEvents = dayEvents.concat(recurringDayEvents);

          // Blocking: Sammle welche Personen ein Multi-Day Event an diesem Tag haben
          var blockedPersons = {};
          for (var mi = 0; mi < self.multiDayEvents.length; mi++) {
            var mde = self.multiDayEvents[mi];
            if (dateKey >= mde.startdatum && dateKey <= mde.enddatum) {
              if (mde.zustaendig === 'Andreas & Nicole') {
                blockedPersons['Andreas'] = true;
                blockedPersons['Nicole'] = true;
              } else if (mde.zustaendig === 'Andreas' || mde.zustaendig === 'Nicole') {
                blockedPersons[mde.zustaendig] = true;
              }
            }
          }
          if (Object.keys(blockedPersons).length > 0) {
            allDayEvents = allDayEvents.filter(function (e) {
              return !blockedPersons[e.zustaendig];
            });
          }

         // Multi-Day Bar Info (visual spanning via ::before, no pill)
         var multiDayInfo = self.getMultiDayInfo(dateKey);
         var multiDayAttrs = '';
         if (multiDayInfo) {
           multiDayAttrs = ' data-multiday="' + multiDayInfo.position + '" data-multiday-label="' + self.escapeHtml(multiDayInfo.label) + '"';
           if (multiDayInfo.color) multiDayAttrs += ' style="--badge-color:' + multiDayInfo.color + '"';
         }

         let eventsHtml = '';
         const maxVisible = 2;
         const remaining = allDayEvents.length - maxVisible;

         allDayEvents.slice(0, maxVisible).forEach(function (event) {
           var pillAttrs = '';
           var pillColor = typeof badgeColorMap !== 'undefined' ? (badgeColorMap[event.zustaendig] || '') : '';
           if (pillColor) pillAttrs += ' style="--badge-color:' + pillColor + '"';
           if (event.weekday) pillAttrs += ' data-recurring="true"';
           eventsHtml += `
             <div class="desight-events__calendar-event-pill" data-zustaendig="${self.escapeHtml(event.zustaendig || '')}" data-event-id="${event.id}" data-event-date="${dateKey}"${pillAttrs}>
               <span class="desight-events__calendar-event-pill-dot"></span>
               <span class="desight-events__calendar-event-pill-title">${self.escapeHtml(event.title)}</span>
               ${event.zeitfenster ? `<span class="desight-events__calendar-event-pill-time">${self.escapeHtml(event.zeitfenster)}</span>` : ''}
             </div>
           `;
         });

         if (remaining > 0) {
            eventsHtml += `<div class="desight-events__calendar-more" data-date="${dateKey}">+${remaining} mehr</div>`;
         }

        const hasEventsClass = (allDayEvents.length > 0 || multiDayInfo) ? 'has-events' : '';
        const todayClass = isToday ? 'is-today' : '';
        const pastClass = isPast ? 'is-past' : '';

         html += `
           <div class="desight-events__calendar-day ${hasEventsClass} ${todayClass} ${pastClass}${multiDayAttrs ? ' has-multiday' : ''}" data-date="${dateKey}"${multiDayAttrs}>
             <span class="desight-events__calendar-day-number">${day}</span>
             <div class="desight-events__calendar-day-events">
               ${eventsHtml}
             </div>
           </div>
         `;
      }

      container.innerHTML = html;

      // Event Listener für Event-Pills
       const pills = container.querySelectorAll('.desight-events__calendar-event-pill');
       pills.forEach(function (pill) {
         pill.addEventListener('click', function (e) {
           e.stopPropagation();
           const eventId = this.getAttribute('data-event-id');
           const eventDate = this.getAttribute('data-event-date');
           self.handleEventClick(eventId, eventDate);
         });
       });

       // Event Listener für Multi-Day Zellen
       const multiDayCells = container.querySelectorAll('.desight-events__calendar-day.has-multiday');
        multiDayCells.forEach(function (cell) {
          cell.addEventListener('click', function (e) {
            if (e.target.closest('.desight-events__calendar-event-pill')) return;
            const dateKey = this.getAttribute('data-date');
            var mdi = self.getMultiDayInfo(dateKey);
            if (mdi) self.handleEventClick(mdi.event.id, dateKey);
          });
        });

       // Event Listener für "+N mehr" Button
       var moreButtons = container.querySelectorAll('.desight-events__calendar-more');
       moreButtons.forEach(function (btn) {
         btn.addEventListener('click', function (e) {
           e.stopPropagation();
           var dk = this.getAttribute('data-date');
           var dayCell = container.querySelector('.desight-events__calendar-day[data-date="' + dk + '"]');
           if (!dayCell) return;
           var ec = dayCell.querySelector('.desight-events__calendar-day-events');
           if (!ec) return;
           var di = (new Date(dk + 'T00:00:00').getDay() + 6) % 7;
           var wm = {'Mo':'Montag','Di':'Dienstag','Mi':'Mittwoch','Do':'Donnerstag','Fr':'Freitag','Sa':'Samstag','So':'Sonntag'};
           var wkday = wm[self.weekdayNames[di]];
             var allEvts = (self.eventsByDate[dk] || []).concat(self.recurringEvents.filter(function (ev) { return ev.weekday === wkday; }));
             // Blocking: Multi-Day Override (inkl. Single-Person Multi-Day)
             var blockedMore = {};
             for (var mj = 0; mj < self.multiDayEvents.length; mj++) {
               var mde2 = self.multiDayEvents[mj];
               if (dk >= mde2.startdatum && dk <= mde2.enddatum) {
                 if (mde2.zustaendig === 'Andreas & Nicole') {
                   blockedMore['Andreas'] = true; blockedMore['Nicole'] = true;
                 } else if (mde2.zustaendig === 'Andreas' || mde2.zustaendig === 'Nicole') {
                   blockedMore[mde2.zustaendig] = true;
                 }
               }
             }
             if (Object.keys(blockedMore).length > 0) {
               allEvts = allEvts.filter(function (e) { return !blockedMore[e.zustaendig]; });
             }
           var fh = '';
           allEvts.forEach(function (ev) {
             var pa = '';
             var pc = badgeColorMap[ev.zustaendig] || '';
             if (pc) pa += ' style="--badge-color:' + pc + '"';
             if (ev.weekday) pa += ' data-recurring="true"';
             fh += '<div class="desight-events__calendar-event-pill" data-zustaendig="' + self.escapeHtml(ev.zustaendig || '') + '" data-event-id="' + ev.id + '" data-event-date="' + dk + '"' + pa + '><span class="desight-events__calendar-event-pill-dot"></span><span class="desight-events__calendar-event-pill-title">' + self.escapeHtml(ev.title) + '</span>' + (ev.zeitfenster ? '<span class="desight-events__calendar-event-pill-time">' + self.escapeHtml(ev.zeitfenster) + '</span>' : '') + '</div>';
           });
           ec.innerHTML = fh;
           ec.querySelectorAll('.desight-events__calendar-event-pill').forEach(function (p) {
             p.addEventListener('click', function (pe) {
               pe.stopPropagation();
               self.handleEventClick(this.getAttribute('data-event-id'), this.getAttribute('data-event-date'));
             });
           });
         });
       });
     },

     handleEventClick: function (eventId, eventDate) {
       var event = null;

       var allSingle = this.eventsByDate[eventDate] || [];
       for (var i = 0; i < allSingle.length; i++) {
         if (allSingle[i].id === eventId) {
           event = allSingle[i];
           break;
         }
       }

       if (!event) {
         for (var j = 0; j < this.recurringEvents.length; j++) {
           if (this.recurringEvents[j].id === eventId) {
             var src = this.recurringEvents[j];
             event = {
               id: src.id,
               title: src.title,
               startdatum: eventDate,
               enddatum: src.enddatum,
               zeitfenster: src.zeitfenster,
               weekday: src.weekday,
               externalUrl: src.externalUrl,
               imageSrc: src.imageSrc,
               imageAlt: src.imageAlt,
               description: src.description,
               zustaendig: src.zustaendig
             };
             break;
           }
         }
       }

       if (!event) {
         for (var k = 0; k < this.multiDayEvents.length; k++) {
           if (this.multiDayEvents[k].id === eventId) {
             var mde = this.multiDayEvents[k];
             event = {
               id: mde.id,
               title: mde.title,
               startdatum: eventDate,
               enddatum: mde.enddatum,
               zeitfenster: mde.zeitfenster,
               externalUrl: mde.externalUrl,
               imageSrc: mde.imageSrc,
               imageAlt: mde.imageAlt,
               description: mde.description,
               zustaendig: mde.zustaendig
             };
             break;
           }
         }
       }

       if (!event) return;

       if (this.clickAction === 'external' && event.externalUrl) {
         window.open(event.externalUrl, '_blank');
       } else {
         this.showEventPopup(event);
       }
     },

     handleDayClick: function (dateKey) {
       var daySingle = this.eventsByDate[dateKey] || [];
       var dateObj = new Date(dateKey + 'T00:00:00');
       var dayIndex = (dateObj.getDay() + 6) % 7;
       var weekdayAbbr = this.weekdayNames[dayIndex];
       var weekdayMap = {
         'Mo': 'Montag', 'Di': 'Dienstag', 'Mi': 'Mittwoch',
         'Do': 'Donnerstag', 'Fr': 'Freitag', 'Sa': 'Samstag', 'So': 'Sonntag'
       };
       var dayWeekday = weekdayMap[weekdayAbbr];
       var dayRecurring = this.recurringEvents.filter(function (e) {
         return e.weekday === dayWeekday;
       });
         var dayEvents = daySingle.concat(dayRecurring);
         // Blocking: Multi-Day Override (inkl. Single-Person Multi-Day)
         var blockedDay = {};
         for (var dk2 = 0; dk2 < this.multiDayEvents.length; dk2++) {
           var mde3 = this.multiDayEvents[dk2];
           if (dateKey >= mde3.startdatum && dateKey <= mde3.enddatum) {
             if (mde3.zustaendig === 'Andreas & Nicole') {
               blockedDay['Andreas'] = true; blockedDay['Nicole'] = true;
             } else if (mde3.zustaendig === 'Andreas' || mde3.zustaendig === 'Nicole') {
               blockedDay[mde3.zustaendig] = true;
             }
           }
         }
         if (Object.keys(blockedDay).length > 0) {
           dayEvents = dayEvents.filter(function (e) { return !blockedDay[e.zustaendig]; });
         }

       if (dayEvents.length === 0) {
         var multiDayInfo = this.getMultiDayInfo(dateKey);
         if (multiDayInfo) {
           this.handleEventClick(multiDayInfo.event.id, dateKey);
         }
       }
     },

     showEventPopup: function (event) {
       const self = this;
       let popup = document.querySelector('.desight-events__event-popup');

       if (!popup) {
         const template = document.getElementById('desight-events__event-popup-' + this.sectionId);
         if (template) {
           popup = document.createElement('div');
           popup.className = 'desight-events__event-popup';
           popup.innerHTML = template.innerHTML;
           document.body.appendChild(popup);
         }
       }

       if (!popup) return;

       const imgEl = popup.querySelector('.desight-events__event-popup-image');
       const titleEl = popup.querySelector('.desight-events__event-popup-title');
       const dateEl = popup.querySelector('.desight-events__event-popup-date');
       const timeEl = popup.querySelector('.desight-events__event-popup-time');
       const descEl = popup.querySelector('.desight-events__event-popup-description');
       const actionsEl = popup.querySelector('.desight-events__event-popup-actions');
       const badgesEl = popup.querySelector('.desight-events__event-popup-badges');

       if (imgEl) {
         if (event.imageSrc) {
           imgEl.innerHTML = '<img src="' + event.imageSrc + '" alt="' + self.escapeHtml(event.imageAlt || event.title) + '" loading="lazy">';
           imgEl.style.display = '';
         } else {
           imgEl.style.display = 'none';
         }
       }
       if (titleEl) titleEl.textContent = event.title || '';

       var dateStr = event.startdatum ? this.formatDisplayDate(event.startdatum) : '';
       if (event.enddatum && event.enddatum !== event.startdatum) {
         dateStr += ' – ' + this.formatDisplayDate(event.enddatum);
       }
       if (dateEl) dateEl.textContent = dateStr || event.weekday || '';

       if (timeEl && event.zeitfenster) {
         timeEl.textContent = event.zeitfenster;
         timeEl.style.display = '';
       } else if (timeEl) {
         timeEl.style.display = 'none';
       }
       if (descEl) {
         descEl.innerHTML = event.description || '';
         descEl.style.display = event.description ? '' : 'none';
       }
       if (badgesEl) {
         badgesEl.innerHTML = '';
         if (event.zustaendig) {
           var badgeColors = {
             'Andreas': '#d4a574', 'Nicole': '#a8c9a5', 'Katharina': '#c9b8e8', 'Constanze': '#a8c5da', 'Alle': '#d4c98a', 'Andreas & Nicole': '#d4b896'
           };
           var badgeImages = {
             'Andreas': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/andreas_badge.png?v=1778846734',
             'Nicole': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/nicole_badge.png?v=1778846735',
             'Katharina': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/katharina_badge.png?v=1778846734',
             'Constanze': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/constanze_badge.png?v=1778846735',
             'Alle': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/alle_badge.png?v=1778846735',
             'Andreas & Nicole': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/andreas-und-nicole_badge.png?v=1779132893'
           };
           var imgTag = badgeImages[event.zustaendig] ? '<img class="desight-events__zustaendig-badge-img" src="' + badgeImages[event.zustaendig] + '" alt="' + self.escapeHtml(event.zustaendig) + '">' : '';
           badgesEl.innerHTML = '<span class="desight-events__zustaendig-badge" style="--badge-color: ' + (badgeColors[event.zustaendig] || '#ccc') + '">' + imgTag + self.escapeHtml(event.zustaendig) + '</span>';
         }
       }
       if (actionsEl) {
         actionsEl.innerHTML = '';
         if (event.externalUrl) {
           actionsEl.innerHTML = '<a href="' + event.externalUrl + '" class="button button--primary" target="_blank" rel="noopener noreferrer">Mehr erfahren<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg></a>';
         }
       }

        document.body.classList.add('desight-events-popup-open');
        this.popup = popup;

        requestAnimationFrame(function () {
          popup.classList.add('is-active');
        });

        const closeBtn = popup.querySelector('.desight-events__event-popup-close');
        if (closeBtn && !closeBtn._bound) {
          closeBtn._bound = true;
          closeBtn.addEventListener('click', function () {
            self.closePopup();
          });
        }

        const backdrop = popup.querySelector('.desight-events__event-popup-backdrop');
        if (backdrop && !backdrop._bound) {
          backdrop._bound = true;
          backdrop.addEventListener('click', function () {
            self.closePopup();
          });
        }
     },

     showDayPopup: function (dateKey, events) {
     },

    closePopup: function () {
      const popup = document.querySelector('.desight-events__event-popup');
      if (popup) {
        popup.classList.remove('is-active');
        document.body.classList.remove('desight-events-popup-open');
        this.popup = null;
      }
    },

    formatDateKey: function (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },

    formatDisplayDate: function (dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return day + '.' + month + '.' + year;
    },

     escapeHtml: function (text) {
       _escapeDiv.textContent = text || '';
       return _escapeDiv.innerHTML;
     }
   };

   function initFilters() {
      var badgeImages = {
        'Andreas': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/andreas_badge.png?v=1778846734',
        'Nicole': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/nicole_badge.png?v=1778846735',
        'Katharina': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/katharina_badge.png?v=1778846734',
        'Constanze': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/constanze_badge.png?v=1778846735',
        'Alle': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/alle_badge.png?v=1778846735',
        'Andreas & Nicole': 'https://cdn.shopify.com/s/files/1/0360/9883/4568/files/andreas-und-nicole_badge.png?v=1779132893'
      };
      var badgeColors = {
        'Andreas': '#d4a574',
        'Nicole': '#a8c9a5',
        'Katharina': '#c9b8e8',
        'Constanze': '#a8c5da',
        'Alle': '#d4c98a',
        'Andreas & Nicole': '#d4b896'
      };
     var filterBars = document.querySelectorAll('.desight-events__filter-bar');
     filterBars.forEach(function (bar) {
       var sectionId = bar.getAttribute('data-section-id');
       var badges = bar.querySelectorAll('.desight-events__filter-badge');
       var activeFilters = [];

       badges.forEach(function (b) {
         activeFilters.push(b.getAttribute('data-filter'));
         var filterVal = b.getAttribute('data-filter');
         var color = badgeColors[filterVal] || '#ccc';
         b.style.setProperty('--badge-color', color);
         if (badgeImages[filterVal]) {
           var img = document.createElement('img');
           img.className = 'desight-events__filter-badge-img';
           img.src = badgeImages[filterVal];
           img.alt = filterVal;
           b.insertBefore(img, b.firstChild);
         }
       });

       // Badge images auch in Grid-Items setzen
       updateBadgeImages(badgeImages);

       badges.forEach(function (badge) {
         badge.addEventListener('click', function () {
           var filter = this.getAttribute('data-filter');
           this.classList.toggle('is-active');

           if (this.classList.contains('is-active')) {
             if (activeFilters.indexOf(filter) === -1) activeFilters.push(filter);
           } else {
             var idx = activeFilters.indexOf(filter);
             if (idx !== -1) activeFilters.splice(idx, 1);
           }

           applyFilter(sectionId, activeFilters);
         });
       });

       function applyFilter(sectionId, activeFilters) {
         var filterAll = activeFilters.length === badges.length || activeFilters.length === 0;
         var grid = document.getElementById('Slider-' + sectionId);
         if (grid) {
           var items = grid.querySelectorAll('.desight-events__item');
           items.forEach(function (item) {
             var z = item.getAttribute('data-zustaendig');
             if (filterAll || activeFilters.indexOf(z) !== -1) {
               item.style.removeProperty('display');
               item.setAttribute('data-filtered', 'false');
             } else {
               item.style.setProperty('display', 'none', 'important');
             }
            });
            }
          var calendarView = bar.closest('.color, .color-scheme-gradient, [class*="color-"]')
                        || bar.closest('.page-width, .isolate');
       if (calendarView) calendarView = calendarView.querySelector('[data-view-container="calendar"]');
          if (calendarView && calendarView.style.display !== 'none') {
            var cal = calendarView.querySelector('.desight-events__calendar');
            if (cal) {
              var mgr = cal._calendarManager;
            if (mgr) {
              mgr.events = [];
              mgr.eventsByDate = {};
              mgr.recurringEvents = [];
              mgr.multiDayEvents = [];
              mgr.activeFilters = activeFilters;
              mgr.filterAll = filterAll;
              mgr.loadEvents();
              mgr.render();
              }
            }
          }
        }
      });
      function updateBadgeImages(images) {
         var gridBadges = document.querySelectorAll('.desight-events__zustaendig-badge');
         gridBadges.forEach(function (badge) {
           var name = badge.textContent.trim();
           var color = badgeColorMap[name] || '';
           if (color) badge.style.setProperty('--badge-color', color);
           if (images[name]) {
             var img = badge.querySelector('img');
             if (!img) {
               img = document.createElement('img');
               img.className = 'desight-events__zustaendig-badge-img';
               badge.insertBefore(img, badge.firstChild);
             }
             img.src = images[name];
             img.alt = name;
           }
         });
       }
    }

   /**
    * Auto-Init
    */
   if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', function () {
       initEvents();
       initFilters();
     });
   } else {
     initEvents();
     initFilters();
   }

   // Bug-Fix: CalendarManager neu initialisieren wenn sich das Grid ändert
   document.addEventListener('shopify:section:load', function (event) {
     var target = event.target || document;
     var calendars = target.querySelectorAll('.desight-events__calendar');
     calendars.forEach(function (cal) {
       if (cal._calendarManager) {
         cal._calendarManager.reload();
       } else {
         new CalendarManager(cal);
       }
     });
     applyGridBlocking();
   });

})();

